import React from 'react';
import { ReactComponent as TipIcon } from '../../../../../resources/img/icons/tips_and_updates.svg';
// import { ReactComponent as ExpandIcon } from '../../../../../resources/img/icons/expand_more.svg';

export const Recommendation = ({ title, description }) => {

  return (
    <div className='recommendation-item' style={{ display: 'flex', padding: '12px', borderRadius: 12, border: '1px solid #FFEFB2', background: '#FFFAE5' }}>
      <TipIcon style={{ display: 'flex', flexShrink: 0, marginRight: 12 }} />

      <div>
        {title && (
          <div className="font-medium" style={{ fontSize: 14, color: '#222', marginBottom: 16 }}>
            {title}
          </div>
        )}

        {description && (
          <div style={{ fontSize: 12, color: '#646464' }}>
            {description}
          </div>
        )}

        {/* Potential actions for future use */}
        {/*<div className="cursor-pointer d-flex align-items-center" style={{ marginTop: 10 }}>*/}
        {/*  <div className="font-medium" style={{ fontSize: 12, color: '#646464' }}>*/}
        {/*    მეტის ნახვა*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <ExpandIcon />*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/*<div*/}
        {/*  className="font-medium cursor-pointer"*/}
        {/*  style={{ fontSize: 12, color: '#fff', borderRadius: 8, background: '#222', padding: '8px 16px', width: 'max-content', marginTop: 16 }}*/}
        {/*>*/}
        {/*  CTA */}
        {/*</div>*/}
      </div>
    </div>
  );
};
